import { gql } from 'apollo-boost';

export const GET_SYSTEM_CHAT_ACTIONS = gql`
    query GetSystemChatActions($scope: ChatActionScopeEnum) {
        getSystemChatActions(scope: $scope) {
            id
            ownerUserId
            slashCommand
            label
            description
            scope
            visibility
            promptTemplate
            isActive
            isSystem
            createdAt
            updatedAt
        }
    }
`;
